import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.763 2.318a.75.75 0 0 1 .803.116q.16.138.36.305c.794.667 1.998 1.678 2.912 3.1.556.866.999 1.987 1.299 2.89q.075.229.14.44c.206-.345.383-.8.45-1.396a.75.75 0 0 1 1.406-.27c.509.947.617 1.18 1.085 2.673.485 1.55.532 2.567.532 3.49 0 3.943-3.01 7.084-6.75 7.084-3.718 0-6.75-2.984-6.75-6.947 0-.892.09-2.255.712-3.331.431-.745.74-1.098 1.124-1.535.115-.13.236-.269.369-.427l.273-.322c.154-.18.247-.289.342-.42.126-.174.25-.386.493-.87.203-.405.397-1.06.54-1.804.141-.736.221-1.499.221-2.094a.75.75 0 0 1 .439-.682m.95 2.217 3 4.667zm3 4.667c.141.425.251.809.325 1.097zm.325 1.097q.056.217.081.343zm.081.343.017.087z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }